import {
	QueryCache,
	QueryClient,
	UseMutationResult,
	useMutation,
	useQueryClient,
} from '@tanstack/react-query'

import { ErrorResponse, UpdateItemResponse } from '@src/interface/api/response.interface'
import { AxiosError } from 'axios'

import { processRefund } from '@src/lib/api/refund/processRefunds/processRefund'
import type { ProcessRefundPayloadType } from '@src/lib/api/refund/processRefunds/processRefund'
import { Refund } from '@src/type/refund'

// const queryClient = useQueryClient()

const useProcessRefundMutate = (
	offset: number,
): UseMutationResult<
	UpdateItemResponse<Refund>,
	AxiosError<ErrorResponse>,
	ProcessRefundPayloadType
> => {
	return useMutation((payload) => processRefund(payload), {
		// onSuccess: () => {
		// 	queryClient.invalidateQueries({ queryKey: ['getRefunds', offset] })
		// },
	})
}

export default useProcessRefundMutate
